import styles from '@/components/Common/TopNav/TopNav.styles';
import { useGlobalContext } from '@/context/Global/GlobalContext';
import { useIsMobile } from '@/utils/isMobile';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import Stack from '@mui/material/Stack';

export default function TopNav() {
  const isMobile = useIsMobile();
  const { setSideMenuOpened } = useGlobalContext();

  if (!isMobile) return null;

  return (
    <Stack
      sx={styles.wrapper}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <IconButton onClick={() => setSideMenuOpened?.(true)}>
        <MenuIcon />
      </IconButton>
    </Stack>
  );
}
